package com.milta.core.localization.translations.ro

import com.milta.core.localization.WebDashboardStrings

internal val WebDashboard = WebDashboardStrings(
    refreshButtonLabel = "Actualizare",
    expandedStopsTitle = "Opriri",
    stopStatusWaitingLabel = "În așteptare",
    stopStatusFailedLabel = "Nelivrat",
)
